import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import { apiUrl, formatDate } from "../util";
import { pollWithRetryPromise } from "../util/pollingPromiseUtil.js";

class RecentQueue extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
    };
  }
  cleanupGetDataPolling = null;
  pollingPromise = null;
  componentDidMount() {
    this.getData();
  }
  componentWillUnmount() {
    if (this.cleanupGetDataPolling) {
      this.cleanupGetDataPolling();
    }
  }
  getData = () => {
    const { pollingPromise, cleanup } = pollWithRetryPromise();
    this.pollingPromise = pollingPromise;
    this.cleanupGetDataPolling = cleanup;
    this.pollingPromise({
      url: `${apiUrl}/v1/admin/trigger_polling_data`,
      form: {
        type: "recentQueueData",
        clearCache: true,
        data: JSON.stringify({today: true})
      },
      retryUrl: `${apiUrl}/v1/admin/get_polling_data`,
      retryForm: {
        type: "recentQueueData",
        data: JSON.stringify({today: true})
      },
      token: this.props.user.token,
    })
      .then(json => {
        // const json = data.data;
        console.log("Fetched data:", json);
        this.setState({
          data: json,
          loading: false,
        });

        if (this.cleanupGetDataPolling) {
          this.cleanupGetDataPolling();
          this.cleanupGetDataPolling = null;
        }
      })
      .catch(err => {
        console.error("Error fetching data:", err);
        this.setState({
          loading: false,
        });
      });
  };
  render() {
    const { user } = this.props;
    const { data } = this.state;
    if (!user) {
      return (
        <Redirect
          to={{ pathname: "/", state: { from: this.props.location } }}
        />
      );
    }

    if (this.state.loading) {
      return <h1>Loading&hellip;</h1>;
    }

    return (
      <div>
        <h1>Queues by Company</h1>
        {data.map(item => {
          return (
            <div><a href={`/screens/${encodeURIComponent(item.url)}`}>{item.url}</a> &middot; {formatDate(item.ctime)} &middot; {item.runCount}</div>
          )
        })}
      </div>
    );
  }
}

export default RecentQueue;
